import { DataBox } from './DataBox'
import { PageHeader } from './PageHeader'

export function InventoryDetails() {
    return (
        <>
            <PageHeader />
            <DataBox />
        </>
    )
}
